import Paths from 'src/paths';
import MainMenuSliderItem from './menu-slider-item';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ImageAssets from 'src/assets/images';
import { __DEV__ } from 'src/utils';
import { useAuthContext } from 'src/contexts/auth-provider';

interface MainMenuSliderProps {
  isFullWidth?: boolean;
  onInvisibleMenu?: (value: boolean) => void;
}

export default function MainMenuSlider(props: MainMenuSliderProps) {
  const { auth } = useAuthContext();
  const spUser = [
    263, 82, 184, 431, 184, 431, 525, 766, 807, 814, 816, 837, 7330, 9423, 13101, 17917, 17918, 17919,
  ].includes(Number(auth?.id));
  return (
    <div
      className={`bg-white w-full ${
        props.isFullWidth ? 'min-w-[14rem]' : 'min-w-[3.15rem]'
      } max-w-[16rem] h-full overflow-y-auto transition-all duration-100 ease-linear`}>
      <a href="/" className="px-2 py-1 border-b-1 lg:hidden">
        <LazyLoadImage src={ImageAssets.Logo} className="h-9" />
      </a>
      {Paths.menus
        ?.filter(f => {
          if (spUser || __DEV__) {
            return f;
          } else {
            return (
              f.path !== Paths.routes.game.sport &&
              f.path !== Paths.routes.game.casino?.root &&
              f.path !== Paths.routes.game.slot.root &&
              f.path !== Paths.routes.game.slot.play &&
              f.path !== Paths.routes.game.fishing.root &&
              f.path !== Paths.routes.game.fishing.play
            );
          }
        })
        .map((menu, i) => {
          return (
            <MainMenuSliderItem
              key={i}
              {...menu}
              // isFirstChild={i === 0}
              isFullWidth={props.isFullWidth}
              onInvisibleMenu={props.onInvisibleMenu}
            />
          );
        })}
      <label className="text-center text-sm text-gray-300 absolute bottom-3 self-center">
        {props.isFullWidth ? 'Version 2.0' : 'V2.0'}
      </label>
    </div>
  );
}
